import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import * as localForage from 'localforage';

@Injectable()

export class dtQBanGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // if (localStorage.getItem('_dtQBan')) {
    //     return true;
    // }
    // if (!localStorage.getItem('_acceptKey')) {
    //     this.router.navigate(['']);
    // } else {
    //     this.router.navigate(['/nhap-ma-quay']);
    // }
    // return false;

    if (localStorage.getItem('_dtQBan')) {
      return true;
    }
    if (!localForage.getItem('_acceptKey')) {
      this.router.navigate(['']);
    } else {
      this.router.navigate(['/nhap-ma-quay']);
    }
    return false;

    //   return new Promise(res => {
    //     localForage.getItem('_dtQBan').then(result => {
    //       if (result) {
    //         res(true);
    //       }
    //     });
    //     localForage.getItem('_acceptKey').then(result => {
    //       if (!result) {
    //         this.router.navigate(['']);
    //       } else {
    //         this.router.navigate(['/nhap-ma-quay']);
    //     }
    //     })
    //     .catch (err => {
    //       return false;
    //     });
    //   });
    // }

    //  return new Promise(res => {
    //   const dtQ = localForage.getItem('_dtQBan').then();
    //   const accKey = localForage.getItem('_acceptKey').then();
    //   if (dtQ) {
    //       return true;
    //   }
    //   if (!accKey) {
    //       this.router.navigate(['']);
    //   } else {
    //       this.router.navigate(['/nhap-ma-quay']);
    //   }
    //   return false;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/dtQBan.guard.ts